
import ReactHTMLTableToExcel from "react-html-table-to-excel"
import moment from 'moment'
import { useSearchParams } from "react-router-dom"

export const CommonForAllAssignedMaintainanceWorkExportData = (props) => {
    const { ExcelData, name, searchName } = props

    const [searchParams] = useSearchParams()
    let DashProjectTypeId = searchParams.get('DashProjectTypeId')

    return (
        <div style={{ display: 'inline', marginLeft: '0px' }}>
            <ReactHTMLTableToExcel
                id="test-table-xls-button"
                table="table-to-FarmerMasterExport"
                className="btn btn-primary float-end download-table-xls-button float-end btn btn-export btn-md mr-1 mb-1 ml-1"
                filename={name}
                sheet={name}
                buttonText="Export"
                style={{ borderColor: 'black' }}
            />


            <table id="table-to-FarmerMasterExport" style={{ display: 'none', width: '100%' }}>

                <h5><span>&emsp;</span></h5>

                <h4 style={{ textAlign: 'center', fontSize: 16 }}>{name}</h4>

                <tr><td></td></tr>

                <thead>
                    <tr style={{ backgroundColor: '#254462', color: "#fff", border: '1px solid white' }}>
                        <th className="sr_no_col">Sr No.</th>
                        <th>Date</th>
                        <th>Work Name</th>
                        <th>Work Assigned By</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        ExcelData && ExcelData.table && ExcelData.table.length > 0 ? ExcelData.table.map((item) => {
                            return (
                                <tr style={{ width: '100%' }}>
                                    <td style={{ textAlign: "center" }}>{item.rowNum ? item.rowNum : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workAssingDate ? moment(item.workAssingDate).format('YYYY-MM-DD') : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workName ? item.workName : '-'}</td>
                                    <td style={{ textAlign: "center" }}>{item.workAssignedBy ? item.workAssignedBy : '-'}</td>
                                </tr>
                            )
                        })
                            :
                            <td colSpan={15}>No data found</td>
                    }
                </tbody>

            </table>
        </div>
    )
}